import { createClient } from "@supabase/supabase-js";

// Public (browser-safe) values only. Never put a secret / service-role key in a
// REACT_APP_* variable — everything here is bundled into the public JavaScript.
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
    throw new Error("Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_PUBLISHABLE_KEY (see .env.example)");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
